import { graphql } from "babel-plugin-relay/macro";
import { Button } from "primereact/button";
import { useMutation } from "react-relay";
import { CreateFileElementButton_CreateFileElementV2Mutation } from "../../../../../../../../__generated__/CreateFileElementButton_CreateFileElementV2Mutation.graphql";
import {
	E_LEARNING_I18N_KEY,
	E_LEARNING_I18N_MAP,
} from "../../../../../../../../lms-admin-impl/i18n/tree.i18n";

const CREATE_FILE_ELEMENT_MUTATION = graphql`
	mutation CreateFileElementButton_CreateFileElementV2Mutation(
		$input: CreateFileElementV2Input!
	) {
		Admin {
			ElearningV2 {
				createFileElement(input: $input) {
					eLearningContentNode {
						...ContentCard_TreeNodeFragment
					}
				}
			}
		}
	}
`;

interface OwnProps {
	eLearningContentNodeId: string;
}

export const CreateFileElementButton = ({ eLearningContentNodeId }: OwnProps) => {
	const [createFileElement, isCreatingTextElement] =
		useMutation<CreateFileElementButton_CreateFileElementV2Mutation>(
			CREATE_FILE_ELEMENT_MUTATION,
		);

	return (
		<Button
			className={"mr-2"}
			disabled={isCreatingTextElement}
			tooltip={`${E_LEARNING_I18N_MAP(E_LEARNING_I18N_KEY.fileElement)} anlegen`}
			icon="pi pi-file"
			onClick={() => {
				createFileElement({
					variables: {
						input: {
							eLearningContentNodeId: eLearningContentNodeId,
							title: "Neues Element",
							fileId: undefined,
						},
					},
				});
			}}
		/>
	);
};
